import React, { useState, useContext } from "react";
import ReactDOM from "react-dom";
import { AuthContext } from "../contexts/AuthContext";
import { submitOrderComplaint } from "../services/nonAuthRequets";
import { toast } from "react-toastify";

const ComplaintSubmitModal = ({ orderNumber, isOpen, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [complain, setComplain] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, logout, user } = useContext(AuthContext);

  // Reset all input fields
  const resetModalFields = () => {
    setName("");
    setEmail("");
    setPhone("");
    setComplain("");
  };

  // Handle complaint submission
  const submitComplain = async (e) => {
    e.preventDefault();

    if (!name || !email || !phone || !complain.trim()) {
      alert("All fields are required.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await submitOrderComplaint({
        name,
        email,
        phoneNumber:phone,
        content:complain,
        trackingNumber:orderNumber,
      });

      
        toast.success("Complaint submitted successfully. We will get back to you soon.");
        resetModalFields();
        setTimeout(() => onClose(), 2000); // Auto-close modal after success
      
    } catch (err) {
      console.error("Error submitting complaint:", err);
      alert(err.response?.data || err.message || "An error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  // Close modal and reset fields
  const handleClose = () => {
    onClose();
    resetModalFields();
  };

  if (!isOpen) return null;

  // The modal content that will be rendered inside modal-root
  const modalContent = (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Submit a Complaint</h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={submitComplain}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone</label>
                <input
                  type="tel"
                  className="form-control"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Tracking Number</label>
                <input
                  type="text"
                  className="form-control"
                  value={orderNumber}
                  disabled
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Your Complaint</label>
                <textarea
                  className="form-control"
                  rows="4"
                  value={complain}
                  onChange={(e) => setComplain(e.target.value)}
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn btn-main" disabled={isLoading}>
                {isLoading ? "Submitting..." : "Submit Complaint"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  // Render the modal inside the modal-root element using React Portal
  return ReactDOM.createPortal(modalContent, document.getElementById("modal-root"));
};

export default ComplaintSubmitModal;
